import Joi from 'joi';

/**
 * Schema to validate checkin/checkout functionality.
 * Ensures:
 * 1. `startsAt` is not in the future.
 * 2. `endsAt` is not in the past.
 * @returns - The Joi schema for validation.
 */
export const checkInOutActionValidationSchema = () => {
	return Joi.object({
		startsAt: Joi.date()
			.required()
			.custom((value, helpers) => {
				if (new Date(value) > new Date()) {
					return helpers.error('date.future', { value });
				}
				return value;
			})
			.messages({
				'date.future': `validations|check-in-out|starts-at-cannot-be-in-the-future`,
				'any.required': `validations|check-in-out|starts-at-required`,
				'date.base': `validations|check-in-out|starts-at-must-be-a-valid-date`,
			}),

		endsAt: Joi.date()
			.required()
			.custom((value, helpers) => {
				if (new Date(value) < new Date()) {
					return helpers.error('date.past', { value });
				}
				return value;
			})
			.messages({
				'date.past': `validations|check-in-out|ends-at-cannot-be-in-the-past`,
				'any.required': `validations|check-in-out|ends-at-required`,
				'date.base': `validations|check-in-out|ends-at-must-be-a-valid-date`,
			}),
	}).unknown(true);
};
